import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {map} from "rxjs/operators";
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {Observable, of} from "rxjs";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {RouterService} from "@biletix/core/services/router.service";
import {ShoppingCart} from "@biletix/core/models/shopping-cart/shopping-cart.model";
import {CartTimeoutService} from "@biletix/core/services/cart-timeout.service";
import { ShoppingCartState } from '@biletix/core/models/state/shopping-cart-state.model';
import { Router } from '@angular/router';
import { isPlatformServer } from '@angular/common';

@Component({
    standalone: false,
    selector: 'btx-wide-cart-dropdown',
    templateUrl: './cart-dropdown.component.html',
    styleUrls: ['./cart-dropdown.component.scss']
})
export class WideCartDropdownComponent extends AbstractionComponent implements OnInit {

    ticketCount$: Observable<number> = of(0);
    shoppingCartState: ShoppingCartState | any;
    cartStateValue: boolean = false;

    constructor(private ticketSaleService: TicketSaleService,
        private cartTimeoutService: CartTimeoutService,
        private router: Router,
        private routerService: RouterService,
        @Inject(PLATFORM_ID) private platformId: string) {
                super();
                router.events.pipe(this.takeUntilDestroy()).subscribe((val) => {
                    this.changeCartState();
                });
    }

    ngOnInit(): void {
        if(!isPlatformServer(this.platformId)){
            
            this.cartTimeoutService
                .shoppingCartStateChange
                .pipe(this.takeUntilDestroy())
                .subscribe(shoppingCartState =>{ 
                    this.shoppingCartState =shoppingCartState;
                });

            //get shopping cart
            this.ticketSaleService
                .getShoppingCart()
                .pipe(this.takeUntilDestroy())
                .subscribe(cart => this.ticketSaleService.setShoppingCart(cart));

            //get ticket count
            this.ticketCount$ = this.ticketSaleService
                .watchShoppingCart
                .pipe(map((cart: ShoppingCart) => cart?.totalTicket ?? 0));
        }
    }

    changeCartState(){
        if (this.router.url.indexOf('/cart') > -1) {
          this.cartStateValue = true;
          //console.log("true");
        }else{
          this.cartStateValue = false;
          //console.log("false");
        }
    }

    isExistShoppingCart(): boolean {
        return this.ticketSaleService.isExistShoppingCart();
    }

    get cartPageUrl() {
        return this.routerService.cartPageUrl;
    }

}
